import * as React from "react";
import { forwardRef } from "react";
const SvgCustomArrow = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M4.5 3L7.5 6L4.5 9", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgCustomArrow);
export default ForwardRef;
